/* tslint:disable */
/* eslint-disable */
/**
 * Search API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface SearchEntryDto
 */
export interface SearchEntryDto {
    /**
     * 
     * @type {string}
     * @memberof SearchEntryDto
     */
    'domainId': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEntryDto
     */
    'aggregateId': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEntryDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEntryDto
     */
    'domainType': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEntryDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEntryDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchEntryDto
     */
    'relationId'?: string | null;
}
/**
 * 
 * @export
 * @interface SearchFilters
 */
export interface SearchFilters {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchFilters
     */
    'typeFilters': Array<string> | null;
}

/**
 * SearchApi - axios parameter creator
 * @export
 */
export const SearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilters: async (tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getFilters', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/search/filters`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [query] 
         * @param {Array<string>} [labels] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [types] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quickSearch: async (tenantId: string, query?: string, labels?: Array<string>, startDate?: string, endDate?: string, types?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('quickSearch', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/search`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (labels) {
                localVarQueryParameter['labels'] = labels;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (types) {
                localVarQueryParameter['types'] = types;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchApi - functional programming interface
 * @export
 */
export const SearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilters(tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchFilters>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilters(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.getFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [query] 
         * @param {Array<string>} [labels] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {Array<string>} [types] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quickSearch(tenantId: string, query?: string, labels?: Array<string>, startDate?: string, endDate?: string, types?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quickSearch(tenantId, query, labels, startDate, endDate, types, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.quickSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SearchApi - factory interface
 * @export
 */
export const SearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchApiFp(configuration)
    return {
        /**
         * 
         * @param {SearchApiGetFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilters(requestParameters: SearchApiGetFiltersRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchFilters> {
            return localVarFp.getFilters(requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchApiQuickSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quickSearch(requestParameters: SearchApiQuickSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SearchEntryDto>> {
            return localVarFp.quickSearch(requestParameters.tenantId, requestParameters.query, requestParameters.labels, requestParameters.startDate, requestParameters.endDate, requestParameters.types, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getFilters operation in SearchApi.
 * @export
 * @interface SearchApiGetFiltersRequest
 */
export interface SearchApiGetFiltersRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchApiGetFilters
     */
    readonly tenantId: string
}

/**
 * Request parameters for quickSearch operation in SearchApi.
 * @export
 * @interface SearchApiQuickSearchRequest
 */
export interface SearchApiQuickSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchApiQuickSearch
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof SearchApiQuickSearch
     */
    readonly query?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof SearchApiQuickSearch
     */
    readonly labels?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof SearchApiQuickSearch
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof SearchApiQuickSearch
     */
    readonly endDate?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof SearchApiQuickSearch
     */
    readonly types?: Array<string>
}

/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
export class SearchApi extends BaseAPI {
    /**
     * 
     * @param {SearchApiGetFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public getFilters(requestParameters: SearchApiGetFiltersRequest, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).getFilters(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchApiQuickSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public quickSearch(requestParameters: SearchApiQuickSearchRequest, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).quickSearch(requestParameters.tenantId, requestParameters.query, requestParameters.labels, requestParameters.startDate, requestParameters.endDate, requestParameters.types, options).then((request) => request(this.axios, this.basePath));
    }
}



